const convertArNumbersToEn = (s: any) => {
    return s.replace(/[٠-٩]/g, (d: any) => "٠١٢٣٤٥٦٧٨٩".indexOf(d))
}

export default convertArNumbersToEn
